// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import 'babel-polyfill'
import MetaInfo from 'vue-meta-info'
import './assets/style/app.styl'
import axiosConfig from './config/axiosConfig'

import myxss from './utils/xss';
Vue.use(MetaInfo)
Vue.prototype.$ELEMENT = ({ size: 'small' });
Vue.config.productionTip = false


Vue.prototype.$xss = (val) => {
    return myxss.process(val);
}

/* eslint-disable no-new */
const vue = new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',
	mounted () {
    // document.dispatchEvent(new Event('render-event'))
}
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js